// react-magnetic-di - temporary comment, for auto dependency injection in tests
import { useEffect } from 'react';

import { useAdjustmentsContextActions } from '../../../../controllers/adjustments-context';
import { useViewType } from '../../../../controllers/issue-adjustments/hooks/use-view-type';
import { useIssueAdjustmentsActions } from '../../../../controllers/issue-adjustments/main';
import { getAnalytics } from '../../../../controllers/view-configuration';

interface ContextClenupPayload {
	executionContextKey: string;
	numberOfSupportedFields?: number;
	resetFormFieldsCounter?: number;
}

export const useContextCleanup = (payload: ContextClenupPayload) => {
	const { executionContextKey, numberOfSupportedFields, resetFormFieldsCounter } = payload;

	const { resetAllFields, triggerFieldInitialization, setNumberOfSupportedFields } =
		useIssueAdjustmentsActions();
	const { resetAdjustmentContext } = useAdjustmentsContextActions();
	const viewType = useViewType();

	useEffect(() => {
		if (numberOfSupportedFields !== undefined) {
			setNumberOfSupportedFields(numberOfSupportedFields);
		}

		return () => setNumberOfSupportedFields(0);
	}, [numberOfSupportedFields, setNumberOfSupportedFields]);

	useEffect(() => {
		triggerFieldInitialization();
		return resetAllFields;
		// Whenever the executionContextKey is changed, or the resetFormFieldsCounter
		// is incremented ("create another issue" GIC) we want to reset any data in our store.
		// For "create another issue" `resetFormFieldsCounter` we trigger re-initialization of field data.
	}, [executionContextKey, resetFormFieldsCounter, resetAllFields, triggerFieldInitialization]);

	useEffect(
		() => () => {
			resetAdjustmentContext();
			getAnalytics(viewType).cancelTTI();
		},
		// When executionContextKey is changed we reset the AdjustmentsContext because
		// other executionContextKey may not be configured to run UI modifications
		[executionContextKey, resetAdjustmentContext, viewType],
	);
};
